import { graphql } from '@/gql'

export const CREATE_ERROR_REPORT = graphql(`
  mutation createErrorReport(
    $error: String!
    $routeName: String!
    $userAgent: JSON!
    $message: String
    $useEmail: Boolean
    $grantAccess: Boolean
    $isCrash: Boolean
  ) {
    createErrorReport(
      input: {
        error: $error
        routeName: $routeName
        userAgent: $userAgent
        message: $message
        useEmail: $useEmail
        grantAccess: $grantAccess
        isCrash: $isCrash
      }
    ) {
      response
    }
  }
`)
